import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';

import { IMapTypes } from './settings';
import { SelectedCoordinate } from '../components/itinenary-list/itinerary';
import { SettingService } from '../services/setting.service';
import { finalize } from 'rxjs/operators';
import { FileDataService } from '../components/services/file-data.service';
import { ChildrenOutletContexts, Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthService } from 'src/app/user/services/auth.service';

@Component({
  selector: 'app-map-settings',
  templateUrl: './map-settings.dialog.html',
  styleUrls: ['./map-settings.dialog.scss']
})
export class MapSettingsDialog implements OnInit{

  @Output() messageEvent = new EventEmitter<string>();
  //property2:string=this.tempRoutefile
  mapTypes:IMapTypes[]= [];
  selectedMapTypes:any = {};
  mapSettingsForm:FormGroup;
  mapOptions: Array<any> = [];
  vehicleList: Array<any> = [];
  drivingDirectionList: Array<any> =[];
  userid:string='';
  currentUserName:any;
  currentUserId: string;
  tempRoutefile:any[]=[];

  selectedMaps:Array<any>=[];
  selectedmapTypes:Array<any>=[];

  routeIntevalTime:number;
  routeIntervalList:Array<any>=[{id:1,intervalTime:1},{id:2,intervalTime:2},{id:3,intervalTime:3},{id:4,intervalTime:4},
                                 {id:5,intervalTime:5},{id:6,intervalTime:6},{id:7,intervalTime:7},{id:8,intervalTime:8},
                                 {id:9,intervalTime:9},{id:10,intervalTime:10},{id:11,intervalTime:11},{id:12,intervalTime:12},
                                 {id:13,intervalTime:13},{id:14,intervalTime:14},{id:15,intervalTime:15},{id:16,intervalTime:16},
                                 {id:17,intervalTime:17},{id:18,intervalTime:18},{id:19,intervalTime:19},{id:20,intervalTime:20},]
  constructor(
    private mapSevice:SettingService,
    private dialogRef: MatDialogRef<MapSettingsDialog>,
    private fileService: FileDataService,
    private router:Router,
    private settingsDialog: MatDialog,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(){
    this.mapSettingsForm = new FormGroup({
      milesDistance : new FormControl(false),
      waypointNumber : new FormControl(false),
      addWayPointPrompt : new FormControl(false),
      selectedCoordinate : new FormControl(SelectedCoordinate.DD),
      recalculateItinerary: new FormControl(false),
      addRouteDirectly : new FormControl(false),
      waypointsOnRoad: new FormControl(false),
      selectedDirectionProvider:new FormControl(''),
      selectedVehicle: new FormControl(''),
      selectedDrivingDirection: new FormControl(''),
      avoidHighways: new FormControl(false),
      avoidTolls:new FormControl(false),
      selectedRouteInterval:new FormControl('')
    });
    this.onChangeOfDirectionProvider();
    this.onChangeOfVehicle();
    this.onChangeRouteInterval();
    //#BugFix: Timer is added as fallback for 'ExpressionChangedAfterChecked' error
    setTimeout(() => {
      this.initializeFormValues();
    });
    this.getAllLoginUsers()
  }

  initializeFormValues(){
    this.currentUserId = JSON.parse(sessionStorage.getItem('currentUser')).userId;
    this.mapSevice.getMapSettings(this.currentUserId)
        .subscribe(
          (res:any) => {
            if(res.responseStatus === 'Success' ){
              const mapData = res.responseData;
              // Dropdown Values
            //  this.mapTypes = this.populateMapTypeData(mapData.maps);
            this.mapTypes = this.populateMapTypeData(mapData.maps);
             // this.mapOptions = Object.entries(mapData.directionProviders);
             this.selectedMaps= Object.entries(mapData.directionProviders);
                for(let listMaps of  this.selectedMaps){
                  if(listMaps[0]=="Tom Tom Maps" ||listMaps[0]=="OpenStreetMap"){
                    this.mapOptions.push(listMaps);
                  }
                }
              //  for( let mapData of this.selectedMapTypes){
              //    for(let ma of mapData.children){
              //      if(ma.name=="HERE MAPS"){
              //        this.mapTypes=this.populateMapTypeData(ma)
              //      }


              //    }
              //   }

              // Form Values
              this.mapSettingsForm.patchValue(mapData)
            } else if (res.responseCode != null && res.responseCode.statusCode === 401) {
              this.authService.logout();
              this.dialogRef.close();
              this.router.navigate(['/user/login']);
            }
          },
          err => console.log('Error while Map Dropdown values:', err)
        );
  }

  onChangeOfDirectionProvider(){
    this.mapSettingsForm.get('selectedDirectionProvider').valueChanges.subscribe(
      directionProvider => {
        const selectedDirectionProvider= this.mapOptions.find(item => item[0] === directionProvider);
        this.vehicleList = selectedDirectionProvider ? selectedDirectionProvider[1] : [];
        this.mapSettingsForm.patchValue({
          selectedVehicle:this.vehicleList.length ? this.vehicleList[0].name: null
        })
      }
    );
  }


  onChangeRouteInterval(){
    this.mapSettingsForm.get('selectedRouteInterval').valueChanges.subscribe(routeInterval=>{
      const selectedRouteInterval1 = this.routeIntervalList.find(item => item[0] === routeInterval);
      if(selectedRouteInterval1){
         this.mapSettingsForm.patchValue({
          selectedRouteInterval:this.routeIntervalList.length?this.routeIntervalList[0].intervalTime:null
      })
      }
    });
  }

  onChangeOfVehicle(){
    this.mapSettingsForm.get('selectedVehicle').valueChanges.subscribe(
      vehicle => {
        const selectedVehicle = this.vehicleList.find(item => item.name === vehicle);
        if(selectedVehicle){
          this.drivingDirectionList = Object.entries(selectedVehicle.drivingDirection);
          this.mapSettingsForm.patchValue({
            selectedDrivingDirection: this.drivingDirectionList.length ? this.drivingDirectionList[0][1] : '',
            avoidHighWays: selectedVehicle.avoidHighwaysEnabled,
            avoidTolls: selectedVehicle.avoidTollsEnabled
          });
        }
      }
    );
  }
  /** Helper function for populating default value
   *  in `Selected vehicle `  field
   */
  compareWithVehicle(vehicle1:any,vehicle2:any){
    return vehicle1 === vehicle2
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  onSubmit() :void{
    this.mapSevice.saveMapSettings({
      ...this.mapSettingsForm.value,
      maps : this.selectedMapTypes,
      user_id : this.currentUserId
    }).pipe(
      finalize( () => {
        this.closeDialog();
      })
    ).subscribe((res:any) => {
      if(res.responseStatus === 'Success'){
        this.mapSevice.changeLocalMapSettings({...this.mapSettingsForm.value, maps: this.selectedMapTypes});
      }
    });
  }
  populateMapTypeData(data:{key:string,value:Array<string>}){
    const finalData:IMapTypes[] = [];
    for (const property in data) {
        const res ={
          name :property,
          isSelected : data[property].isMapSelected,
          isImplemented :false,
          childrens: data[property].subMaps.map((item:any) => {
             if(item.subMapName=="HERE MAPS" ||item.subMapName=="HERE Maps"|| item.subMapName=="OpenStreetMap" || item.subMapName=="Tomtom Routes" ||item.subMapName=="ViaMichelin" ){
              return {
               name:item.subMapName, 
              isSelected : item.isSubMapSelected,
              isImplemented :item.isImplemented
            }           
            }           
          }),
                  
        }
        const result={ 
          name:property,
          isSelected : data[property].isMapSelected,
          isImplemented :false,
          children:res.childrens.filter( (element:any) => {
          return element !== undefined;
          
       })
      }
        finalData.push(result);
    }
    return finalData;
  }

  selectionBasedMapTypes(list:any, isSubMapSelected:boolean){
    const subMapList = [];
    list.forEach( (item:any) => {
      if(item.level === 1){
        subMapList.push({
                subMapName: item.name,
                isImplemented : item.isImplemented,
                isSubMapSelected
          })
      }
    });
    return subMapList
  }
  getMapTypes( allItems:any, mapType:string){
    const selectedItems = this.selectionBasedMapTypes(allItems.selected, true);
    const deselectedItems = this.selectionBasedMapTypes(allItems.deselected, false);
    const allData = [...selectedItems,...deselectedItems];
    if(allData.length){
      this.selectedMapTypes[mapType] ={
        mainMapName:mapType,
        isMapSelected : true,
        subMaps : allData
      };
    }
  }
  getAllLoginUsers(){
    this.fileService.getLoginUsers().subscribe((data:any)=> {
    if (data.responseStatus === "Success") {
        var email=data.responseData;
        const storedUser = JSON.parse(sessionStorage.getItem('currentUser'));
        this.userid=storedUser.userId
        this.currentUserName=email.responseData.filter(b => b.userId==this.userid)[0]
    } else if (data.responseCode != null && data.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      }
    },
     (err) => console.log("Error while get all users: ", err)
    ); 
  }

  reloadFile(){
    var username=this.currentUserName.firstName;
    this.fileService.recoverFile(username).subscribe((res:any)=>{
      this.fileService.tempRoutefile=res;
      this.fileService.isTempRoute=true;
     this.router.navigate(['./file-import'])
    })
    this.settingsDialog.closeAll();
   // this.loader.hide();
    this.closeDialog()

  }

  ngOnDestroy(): void {
    this.settingsDialog.closeAll();
    this.closeDialog();

  }

 }
